export enum CategoryNameEnum {
  Painting = 'painting',
  Sculpture = 'sculpture',
  Photography = 'photography',
  Graphics = 'graphics',
  Drawing = 'drawing',
  VideoArt = 'videoArt',
  ArtInstallation = 'artInstallation',
  DigitalArt = 'digitalArt',
  Design = 'design',
  Other = 'other'
}
